import { CalendarHolidaysRepository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: CalendarHolidaysRepository): Interactor {
  return (calendarHolidays) =>
    present(
      repository
        .removeCalendarHolidays(calendarHolidays)
        .then(() => calendarHolidays)
        .catch((e) =>
          Promise.reject({ ...e, message: e.detail, calendarHolidays }),
        ),
    );
}
export type { Interactor };

export { createInteractor };
